// extracted by mini-css-extract-plugin
export default {"fallbackSpinner":"generalFallBack_fallbackSpinner__gA5NX"};